import { Fragment, useMemo } from "react";

function Toolbar({ total, start = 0, limit, setStart }) {
    const pages = useMemo(() => {
        const pages = [];
        const totalPages = Math.ceil(total / limit);
        const currentPage = start / limit + 1;

        let afterPages = Math.min(totalPages - currentPage, 4);
        let beforePages = Math.min(currentPage - 1, 4);

        if (beforePages >= 2 && afterPages >= 2) {
            beforePages = 2;
            afterPages = 2;
        }

        if (beforePages + afterPages > 4 && beforePages > afterPages) {
            beforePages = beforePages - afterPages;
        }

        if (beforePages + afterPages > 4 && afterPages > beforePages) {
            afterPages = afterPages - beforePages;
        }

        if (currentPage >= 4 && totalPages > 5) {
            pages.push({
                num: "«",
                limit: 0,
                isActive: false,
                class: "",
            });
        }

        for (
            let i = currentPage - beforePages;
            i <= afterPages + currentPage;
            i++
        ) {
            pages.push({
                num: i,
                isActive: i === currentPage,
                limit: (i - 1) * limit,
                class: i === currentPage ? "active" : "",
            });
        }

        return pages;
    }, [total, start, limit]);

    const handleClick = (e, page) => {
        e.target.blur();
        setStart(page);
    };

    return (
        <div className="btn-toolbar mt-3">
            {/* <div className="btn-group">
                <div className="input-group-text bg-transparent text-muted border-0">
                    Sort
                </div>
                <a
                    href="#"
                    className="btn btn-outline-secondary rounded-start active"
                >
                    Pinned
                </a>
                <a href="#" className="btn btn-outline-secondary">
                    Name
                </a>
                <a href="#" className="btn btn-outline-secondary">
                    Price
                </a>
            </div> */}

            <div className="btn-group ms-auto">
                <div
                    className="btn-group"
                    role="group"
                    aria-label="First group"
                >
                    {pages.map((page) => (
                        <Fragment key={page.num}>
                            <input
                                type="radio"
                                className="btn-check"
                                name="start"
                                id={`option` + page.num}
                                autoComplete="off"
                                value={page.limit}
                                checked={page.isActive}
                                onChange={(e) => handleClick(e, page.limit)}
                            />
                            <label
                                className={`btn btn-outline-secondary border-primary ${page.class}`}
                                htmlFor={`option` + page.num}
                            >
                                {page.num}
                            </label>
                        </Fragment>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Toolbar;
